import { AlertTriangle, RotateCcw } from 'lucide-react';
import { useActiveYear } from '../../contexts/ActiveYearContext';

/**
 * Sticky banner shown when the viewer is browsing a year other than the
 * org's current global active year. Lets them snap back with one click.
 *
 * Lives at the very top of the app shell so it's visible regardless of
 * which route is open.
 */
export default function YearOverrideBanner() {
  const { isOverriding, year, globalYear, clearOverride } = useActiveYear();

  if (!isOverriding || year === null || globalYear === null) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      className="sticky top-0 z-40 w-full bg-amber-100 dark:bg-amber-900/40 border-b border-amber-300 dark:border-amber-700 text-amber-900 dark:text-amber-100 px-4 py-2.5 flex items-center justify-center gap-3 flex-wrap text-sm font-medium"
    >
      <AlertTriangle className="w-4 h-4 flex-shrink-0" aria-hidden="true" />
      <span>
        You're viewing <strong>{year}</strong>, not the current planning year (
        <strong>{globalYear}</strong>). Tasks and milestones can't be created for past years.
      </span>
      <button
        type="button"
        onClick={clearOverride}
        className="inline-flex items-center gap-1.5 px-3 py-1 rounded-md bg-amber-200 dark:bg-amber-800 hover:bg-amber-300 dark:hover:bg-amber-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-amber-500 text-amber-900 dark:text-amber-50"
      >
        <RotateCcw className="w-3.5 h-3.5" aria-hidden="true" />
        Return to current year
      </button>
    </div>
  );
}
